import React from 'react'
import './Ministries.css'
import '../../../App.css'
import '../SubLinks.css'
import MinistryLinks from '../MinistryLinks';
import { Link } from 'react-router-dom'

function ChildrensMinistry() {
    return (
        <div>
            <div className='hero-container children half'>
                <h1></h1>
            </div>
        <div className='main-grid-container'>
          <div className='main-grid-item'>
        <MinistryLinks/>
        </div>
        <div className='main-grid-item'>
        <div className='main with-sublinks'>
                <h1>Children's Ministry</h1>

                <div className='blockquote-container'>
                    <blockquote> Fathers, do not provoke your children to anger, but bring them up in the discipline and instruction of the Lord.
                        <cite> - Ephesians 6:4</cite>
                    </blockquote>
                    </div> 
                <br/>
                <p>
                    The Children’s Ministry of Grace Community Fellowship seeks to glorify our Lord through helping parents plant the seed of God’s word in their hearts and lay a foundation for the future.
                </p>
                <p>
                If you are interested in learning more about our Children's Ministry please <Link to='/contact-us' className='p-link'>contact us</Link>.
                </p>
            </div>
        </div>
        </div>
        </div>
    )
}

export default ChildrensMinistry
